var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4966 3.44664C10.678 2.60112 9.32192 2.60112 8.50323 3.44663L4.50451 7.57641C4.27485 7.81359 4.12053 8.11343 4.06098 8.43816C3.57535 11.0865 3.5395 13.7977 3.95495 16.4579L4.10204 17.3997C4.14849 17.6972 4.40471 17.9165 4.7058 17.9165H7.49993C7.73005 17.9165 7.9166 17.73 7.9166 17.4999V11.6665H12.0833V17.4999C12.0833 17.73 12.2698 17.9165 12.4999 17.9165H15.294C15.5951 17.9165 15.8513 17.6972 15.8978 17.3997L16.0449 16.4579C16.4603 13.7977 16.4245 11.0865 15.9388 8.43816C15.8793 8.11343 15.725 7.81359 15.4953 7.57641L11.4966 3.44664Z",
    fill: "#1B2E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/IconHome.ad940111bdfc1205431a93eea1b34952.svg";
export { ForwardRef as ReactComponent };